import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import queryString from 'query-string';

import LoopbackProvider from '../loopback/LoopbackProvider';
import { BACKEND_URL } from '../environment';
import Loader from '../components/Loader';
import withRouter, { RouteType } from '../hoc/withRouter';

type Props = RouteType;

type State = {
  downloadURLAvailable: string | string[] | null;
  containerName: string | string[] | null;
  fileName: string | string[] | null;
}

class DownloadView extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    const { router } = this.props;
    const query = queryString.parse(router.location.search);
    this.state = {
      downloadURLAvailable: query.containerName && query.fileName,
      containerName: query.containerName,
      fileName: query.fileName,
    };
  }

  componentDidMount() {
    const { router } = this.props;
    if (this.state.downloadURLAvailable) {
      if (LoopbackProvider.loopbackToken) {
        window.location.href = DownloadView.getInvoiceUrl(this.state.containerName, this.state.fileName); // eslint-disable-line
      } else {
        // redirect to login
        router.navigate(`/login?redirect=download&containerName=${this.state.containerName}&fileName=${this.state.fileName}`);
      }
    }
  }

  static getInvoiceUrl = (containerName: string | string[] | null, fileName: string | string[] | null) => `${BACKEND_URL}/Containers/${containerName}/download/${fileName}?access_token=${
    LoopbackProvider.loopbackToken.id
  }`;

  render() {
    return (
      <>
        {this.state && this.state.downloadURLAvailable ? (
          <Loader isLoading />
        ) : (
          <FormattedMessage id="downloadView.downloadNotAvailable" />
        )}
      </>
    );
  }
}

export default withRouter(DownloadView);
